export class WebAppInfo {
 public readonly appVersion = "1.5.30 (1)";

}
